export const SEVERITY_LABELS = [
  '完全沒有',
  '輕微',
  '中等程度',
  '嚴重',
  '非常嚴重',
]

export const BSRS_VALUES = [0, 1, 2, 3, 4];